import React from "react";
import * as styles from "./AboutSection.module.scss";
import {
    container,
} from './main.module.scss'

const AboutSection = ({children, removetop, divContent}) => {

  var setop = true;
  if (removetop === "1") {
    setop = false;
  }

  return (
    <div className={`${styles.aboutSection} ${container} ${setop ? styles.extratopmargin : ""}`}>
      <div className={styles.aboutimg}>
        {children}
      </div>
        <div className={styles.aboutContent}>
            {divContent}
        </div>
    </div>
    
  )
};

export default AboutSection;